<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <div class="col-lg-12">
                <div class="card card-primary card-outline">
                    <div class="card-header">Price Locks</div>
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th scope="col">Branch</th>
                                    <th scope="col">Company</th>
                                    <!--                                    <th scope="col">Lock</th>-->
                                    <th scope="col">Price Lock</th>
                                    <th scope="col">Credit Lock</th>
                                    <th scope="col">Gatepass Lock</th>
                                    <th scope="col">Offer Lock</th>
                                    <th scope="col">Spot Incentive Lock</th>
                                    <th scope="col">DO Approval</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="e in locks">
                                    <td>{{ e.branch_code }}</td>
                                    <td>{{ e.company_code }}</td>
                                    <!--                                    <td>{{ e.lock }}</td>-->
                                    <td>
                                        <button
                                            class="btn btn-success"
                                            v-if="e.lock == 1"
                                            @click="changeLock(e.id)"
                                        >
                                            <i class="fa fa-play"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger"
                                            v-else-if="e.lock == 0"
                                            @click="changeLock(e.id)"
                                        >
                                            <i class="fa fa-square"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-success"
                                            v-if="e.credit_lock == 1"
                                            @click="changeCreditLock(e.id)"
                                        >
                                            <i class="fa fa-play"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger"
                                            v-else-if="e.credit_lock == 0"
                                            @click="changeCreditLock(e.id)"
                                        >
                                            <i class="fa fa-square"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-success"
                                            v-if="e.gatepass_lock == 1"
                                            @click="changeGatepassLock(e.id)"
                                        >
                                            <i class="fa fa-play"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger"
                                            v-else-if="e.gatepass_lock == 0"
                                            @click="changeGatepassLock(e.id)"
                                        >
                                            <i class="fa fa-square"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-success"
                                            v-if="e.offer_lock == 0"
                                            @click="changeOfferLock(e.id)"
                                        >
                                            <i class="fa fa-play"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger"
                                            v-else-if="e.offer_lock == 1"
                                            @click="changeOfferLock(e.id)"
                                        >
                                            <i class="fa fa-square"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-success"
                                            v-if="e.spot_incentive_lock == 0"
                                            @click="
                                                changeSpotIncentiveLock(e.id)
                                            "
                                        >
                                            <i class="fa fa-play"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger"
                                            v-else-if="
                                                e.spot_incentive_lock == 1
                                            "
                                            @click="
                                                changeSpotIncentiveLock(e.id)
                                            "
                                        >
                                            <i class="fa fa-square"></i>
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            class="btn btn-success"
                                            v-if="e.draft_order_approval == 0"
                                            @click="changeDOApproval(e.id)"
                                        >
                                            <i class="fa fa-play"></i>
                                        </button>
                                        <button
                                            class="btn btn-danger"
                                            v-else-if="
                                                e.draft_order_approval == 1
                                            "
                                            @click="changeDOApproval(e.id)"
                                        >
                                            <i class="fa fa-square"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getPriceLocks(pagination.prevPageUrl)"
                            @next="getPriceLocks(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { pagination: Pagination },

    created() {
        this.getPriceLocks();
    },

    data() {
        return {
            locks: [],
            params: new Form({
                results: "",
            }),
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
        };
    },

    methods: {
        getPriceLocks(url = "/api/getPriceLocks") {
            axios.post(url, { params: this.params }).then((response) => {
                this.locks = response.data.data.data;
                this.configPagination(response.data.data);
            });
        },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },

        changeLock(id) {
            axios.post("/api/changePriceLock", { id: id }).then(() => {
                this.getPriceLocks(
                    "/api/getPriceLocks" +
                        "?page=" +
                        this.pagination.currentPage
                );
            });
        },

        changeCreditLock(id) {
            axios.post("/api/changeCreditPriceLock", { id: id }).then(() => {
                this.getPriceLocks(
                    "/api/getPriceLocks" +
                        "?page=" +
                        this.pagination.currentPage
                );
            });
        },

        changeGatepassLock(id) {
            axios.post("/api/changeGatepassPriceLock", { id: id }).then(() => {
                this.getPriceLocks(
                    "/api/getPriceLocks" +
                        "?page=" +
                        this.pagination.currentPage
                );
            });
        },

        changeDOApproval(id) {
            axios.post("/api/changeDOApproval", { id: id }).then(() => {
                this.getPriceLocks(
                    "/api/getPriceLocks" +
                        "?page=" +
                        this.pagination.currentPage
                );
            });
        },

        changeOfferLock(id) {
            axios.post("/api/changeOfferLock", { id: id }).then(() => {
                this.getPriceLocks(
                    "/api/getPriceLocks" +
                        "?page=" +
                        this.pagination.currentPage
                );
            });
        },

        changeSpotIncentiveLock(id) {
            axios.post("/api/changeSpotIncentiveLock", { id: id }).then(() => {
                this.getPriceLocks(
                    "/api/getPriceLocks" +
                        "?page=" +
                        this.pagination.currentPage
                );
            });
        },
    },
};
</script>
